// Contenuti delle "Guide rapide" mostrate in ogni sezione del CRM Amministratore.
// Ogni voce: { title, intro, steps: [{ h, p }], tip? }
// Il resolver getAdminGuide(pathname) cerca prima una corrispondenza ESATTA,
// poi ricade sul PREFISSO piu' lungo (es. /admin/blog/post -> guida "blog").

export const ADMIN_GUIDES = {
  // ---------------- Panoramica ----------------
  '/admin': {
    title: 'Dashboard',
    intro: 'La panoramica in tempo reale della piattaforma: numeri chiave, stakeholder e contenuti pubblicati.',
    steps: [
      { h: 'Leggi i KPI in alto', p: 'Le quattro schede mostrano stakeholder totali, richieste in attesa, articoli del blog ed eventi. Si aggiornano da sole quando arrivano nuove registrazioni.' },
      { h: 'Controlla gli stakeholder', p: 'Il grafico e il riepilogo di stato ti dicono a colpo d\'occhio quanti partner sono approvati, in attesa, sospesi o rifiutati.' },
      { h: 'Agisci sulle attese', p: 'Se vedi un numero in "In attesa", vai in Stakeholder → Richieste in attesa per approvare o rifiutare.' },
    ],
    tip: 'Tieni questa pagina aperta durante le giornate di lancio: le nuove richieste compaiono in tempo reale.',
  },
  '/admin/analytics': {
    title: 'Andamento del Sito',
    intro: 'Qui monitori le visite e il comportamento dei visitatori sul sito pubblico.',
    steps: [
      { h: 'Scegli il periodo', p: 'Usa il selettore delle date per confrontare giorni, settimane o mesi diversi.' },
      { h: 'Guarda le pagine piu\' viste', p: 'Capisci quali contenuti attirano di piu\' e dove concentrare gli aggiornamenti.' },
      { h: 'Usa i dati per il blog', p: 'Se una pagina va forte, valuta un articolo collegato o una campagna newsletter a tema.' },
    ],
  },
  '/admin/cets': {
    title: 'CETS · Sostenibilità',
    intro: 'Monitoraggio degli indicatori della Carta Europea del Turismo Sostenibile.',
    steps: [
      { h: 'Registra le misurazioni', p: 'Inserisci i valori periodici degli indicatori (rifiuti, energia, presenze, ecc.).' },
      { h: 'Confronta nel tempo', p: 'I grafici mostrano l\'andamento: usa i trend per gli obiettivi di miglioramento.' },
      { h: 'Prepara la rendicontazione', p: 'Esporta i dati quando devi documentare i risultati agli enti del Parco.' },
    ],
  },

  // ---------------- Stakeholder ----------------
  '/admin/stakeholders': {
    title: 'Gestione Stakeholder',
    intro: 'Il registro di tutti i partner (hotel, ristoranti, esperienze, guide, e-commerce) con le azioni per gestirli.',
    steps: [
      { h: 'Trova un partner', p: 'Usa la ricerca per nome/email/azienda e i filtri per stato e categoria.' },
      { h: 'Approva o rifiuta', p: 'Sulle richieste in attesa premi Approva per attivarle oppure Rifiuta con eventuale motivo.' },
      { h: 'Sospendi o riattiva', p: 'Puoi sospendere temporaneamente un partner approvato e riattivarlo in seguito.' },
      { h: 'Entra come (impersonation)', p: 'Con "Entra come" operi dentro l\'area del partner per aiutarlo: ti viene chiesto un motivo, tutto viene tracciato nell\'Audit.' },
    ],
    tip: 'Ogni azione sensibile viene registrata: consulta "Audit accessi" per lo storico completo.',
  },
  '/admin/pending': {
    title: 'Richieste in Attesa',
    intro: 'La coda delle nuove registrazioni partner da valutare.',
    steps: [
      { h: 'Verifica i dati', p: 'Controlla nome, azienda ed email prima di approvare: sono i partner che appariranno sul sito.' },
      { h: 'Approva per attivare', p: 'L\'approvazione crea l\'area riservata del partner e ne abilita l\'accesso.' },
      { h: 'Rifiuta se non idoneo', p: 'Il rifiuto blocca l\'accesso; il partner puo\' essere riattivato in futuro se cambia qualcosa.' },
    ],
  },

  // ---------------- Contenuti ----------------
  '/admin/home': {
    title: 'Editor Home',
    intro: 'Modifichi i contenuti della home page pubblica: testi, immagini e sezioni in evidenza.',
    steps: [
      { h: 'Modifica una sezione', p: 'Aggiorna titoli, testi e immagini direttamente nei campi; le immagini si scelgono dalla Galleria ufficiale.' },
      { h: 'Anteprima prima di salvare', p: 'Controlla come apparirà sul sito, poi premi Salva per pubblicare.' },
      { h: 'Coerenza dei messaggi', p: 'Mantieni un tono coerente con blog e social: la home è la prima impressione del visitatore.' },
    ],
  },
  '/admin/galleria': {
    title: 'Galleria Media',
    intro: 'L\'archivio centrale delle immagini usate in tutto il sito e nelle aree partner.',
    steps: [
      { h: 'Carica nuove immagini', p: 'Trascina o seleziona i file: vengono ottimizzati automaticamente in AVIF con una variante mobile piu\' leggera.' },
      { h: 'Organizza e cerca', p: 'Usa la ricerca per ritrovare rapidamente un\'immagine già caricata ed evitare duplicati.' },
      { h: 'Riutilizza ovunque', p: 'Le stesse immagini si selezionano da Home, Pagine, Blog ed Esperienze: carica una volta, usa dappertutto.' },
    ],
    tip: 'Preferisci immagini orizzontali ad alta risoluzione: il sistema le ridimensiona da solo.',
  },
  '/admin/social': {
    title: 'Social',
    intro: 'Colleghi gli account social e pubblichi/pianifichi i post dalla piattaforma.',
    steps: [
      { h: 'Collega gli account', p: 'Autorizza le pagine social; se non compaiono, verifica le chiavi in Connessioni esterne.' },
      { h: 'Crea un post', p: 'Scrivi il testo, scegli un\'immagine dalla Galleria e seleziona i canali di pubblicazione.' },
      { h: 'Pianifica', p: 'Programma la data/ora di uscita per mantenere una presenza costante.' },
    ],
  },
  '/admin/faq': {
    title: 'FAQ',
    intro: 'Gestisci le domande frequenti mostrate ai visitatori (nel footer del sito).',
    steps: [
      { h: 'Crea categorie', p: 'Raggruppa le domande per argomento così i visitatori trovano subito la risposta.' },
      { h: 'Scrivi domanda e risposta', p: 'Usa un linguaggio semplice e diretto; una FAQ chiara riduce le richieste di assistenza.' },
      { h: 'Ordina per priorità', p: 'Metti in cima le domande più comuni.' },
    ],
  },
  '/admin/contatti': {
    title: 'Contatti & Messaggi',
    intro: 'Gestisci i recapiti pubblici e leggi/rispondi ai messaggi del form contatti.',
    steps: [
      { h: 'Aggiorna i recapiti', p: 'Telefono, email, indirizzo, WhatsApp e social appaiono identici sulla pagina pubblica /contatti.' },
      { h: 'Leggi i messaggi', p: 'Nel tab Messaggi trovi le richieste arrivate dal form del sito.' },
      { h: 'Rispondi via Gmail', p: 'Se hai collegato Gmail, puoi rispondere direttamente dal tuo account senza uscire dal CRM.' },
    ],
  },
  // Prefissi (children)
  '/admin/pagine': {
    title: 'Pagine del Sito',
    intro: 'Editor "specchio" delle pagine pubbliche: modifichi il contenuto e lo vedi come apparirà.',
    steps: [
      { h: 'Scegli la pagina', p: 'Dal menu "Pagine sito" apri quella da modificare (La Sila, Alloggi, Privacy, ecc.).' },
      { h: 'Modifica le sezioni', p: 'Aggiorna testi e immagini nei blocchi; l\'anteprima a fianco riflette le modifiche.' },
      { h: 'Salva per pubblicare', p: 'Il salvataggio aggiorna subito la pagina pubblica corrispondente.' },
    ],
    tip: 'Le pagine legali (Privacy, Cookie, Termini) sono già precompilate: personalizzale con i dati reali.',
  },
  '/admin/blog': {
    title: 'Blog / Magazine',
    intro: 'Crei e pubblichi articoli, gestisci categorie, tag, commenti e redattori.',
    steps: [
      { h: 'Scrivi un post', p: 'In Post crea un nuovo articolo: titolo, copertina (dalla Galleria), testo e categoria.' },
      { h: 'Organizza con categorie e tag', p: 'Aiutano i lettori e migliorano la SEO: assegnane sempre almeno una.' },
      { h: 'Anteprima e pubblica', p: 'Usa Anteprima per il controllo finale, poi pubblica; l\'articolo entra anche in sitemap e RSS.' },
      { h: 'Modera i commenti', p: 'Nel tab Commenti approvi o elimini i commenti dei lettori.' },
    ],
  },
  '/admin/newsletter': {
    title: 'Newsletter',
    intro: 'Gestisci iscritti, template e campagne email verso il tuo pubblico.',
    steps: [
      { h: 'Controlla gli iscritti', p: 'Verifica la lista dei contatti e i loro consensi prima di inviare.' },
      { h: 'Prepara un template', p: 'Crea o riusa un modello grafico coerente con il brand.' },
      { h: 'Invia una campagna', p: 'Scrivi l\'oggetto, scegli il template e invia; senza token Postmark l\'invio è in modalità demo.' },
      { h: 'Misura i risultati', p: 'In Statistiche vedi aperture e clic per capire cosa funziona.' },
    ],
  },
  '/admin/esperienze': {
    title: 'Esperienze & Biglietteria',
    intro: 'Gestisci il catalogo esperienze/eventi, la vetrina, le iscrizioni, il check-in e le analitiche.',
    steps: [
      { h: 'Modera il catalogo', p: 'Vedi TUTTE le esperienze dei partner e puoi crearne di tue (etichetta "Gestito dal team").' },
      { h: 'Controlla le iscrizioni', p: 'In Iscrizioni trovi gli acquisti/prenotazioni con i relativi biglietti e QR.' },
      { h: 'Fai il check-in', p: 'Dal Check-in scansioni il QR del biglietto all\'ingresso per validarlo.' },
      { h: 'Analizza le vendite', p: 'La sezione Analytics mostra andamento incassi e presenze.' },
    ],
  },

  '/admin/eventi': {
    title: 'Eventi Piattaforma',
    intro: 'Il centro di controllo del modulo Eventi: catalogo globale, categorie e richieste di attivazione dei partner.',
    steps: [
      { h: 'Catalogo globale', p: 'Vedi TUTTI gli eventi (partner + \u201cTeam Sila\u201d), filtra per categoria/stato e crea eventi gestiti dal team.' },
      { h: 'Categorie', p: 'Crea e personalizza le categorie e i loro colori: appaiono in vetrina e nei filtri del calendario.' },
      { h: 'Richieste', p: 'Approva o rifiuta le richieste \u201cAttiva Evento\u201d dei partner. Il badge rosso indica quante sono in attesa.' },
      { h: 'Pubblicazione', p: 'Puoi pubblicare o ritirare qualsiasi evento; un evento pubblicato compare subito su /eventi.' },
    ],
  },

  // ---------------- Parco ----------------
  '/admin/parco': {
    title: 'Parco · Itinerari',
    intro: 'Gestisci gli itinerari e le aree del Parco mostrati sulle mappe 3D pubbliche.',
    steps: [
      { h: 'Crea/modifica un itinerario', p: 'Imposta nome, descrizione, difficoltà, tracciato e punti d\'interesse con foto.' },
      { h: 'Pubblica sulla mappa', p: 'Gli itinerari pubblicati compaiono su /parco-3d e /parchi con marker e percorsi luminosi.' },
      { h: 'Collega una guida', p: 'Associa una guida approvata: nome e foto appariranno in prenotazione e sui biglietti.' },
    ],
  },
  '/admin/parco/guide': {
    title: 'Guide del Parco',
    intro: 'Approvi le guide, i loro profili e gli itinerari che propongono.',
    steps: [
      { h: 'Valuta l\'account', p: 'Approva o rifiuta la richiesta di registrazione della guida.' },
      { h: 'Approva il profilo', p: 'Confronta le modifiche in attesa con la versione pubblica prima di pubblicarle.' },
      { h: 'Gestisci gli itinerari', p: 'Approva, rifiuta o nascondi i percorsi proposti dalla guida.' },
    ],
  },
  '/admin/prenotazioni': {
    title: 'Prenotazioni Parco',
    intro: 'Il registro delle richieste di prenotazione per itinerari ed escursioni.',
    steps: [
      { h: 'Consulta le richieste', p: 'Vedi data, itinerario, cliente e stato di ogni prenotazione.' },
      { h: 'Gestisci lo stato', p: 'Aggiorna la richiesta man mano che viene confermata o gestita.' },
      { h: 'Coordina con le guide', p: 'Assicurati che la guida associata sia informata delle uscite in programma.' },
    ],
  },

  // ---------------- Sistema ----------------
  '/admin/carrello': {
    title: 'Carrello & Checkout',
    intro: 'Configuri il comportamento del carrello unificato e le regole del checkout.',
    steps: [
      { h: 'Imposta le regole', p: 'Definisci parametri come tempi di riserva (hold), caparre e opzioni di pagamento.' },
      { h: 'Prezzi lato server', p: 'Il prezzo finale è sempre ricalcolato dal server: il cliente viene avvisato se cambia al checkout.' },
      { h: 'Pagamenti', p: 'Stripe è in modalità demo (mock) finché non inserisci le chiavi reali.' },
    ],
  },
  '/admin/tessera': {
    title: 'Tessera & Commissioni',
    intro: 'Gestisci il programma fedeltà (Tessera) e le commissioni della piattaforma per modulo e per partner.',
    steps: [
      { h: 'Imposta le commissioni', p: 'Definisci la percentuale per ciascun modulo (soggiorni, tavoli, esperienze, escursioni, servizi).' },
      { h: 'Override per partner', p: 'Puoi impostare una commissione personalizzata per un singolo stakeholder: vince su quella di modulo.' },
      { h: 'Punti fedeltà', p: 'Configura accredito e riscatto dei punti Tessera per i clienti.' },
      { h: 'Report', p: 'Consulta il report "Maxi Experience" per l\'andamento economico complessivo.' },
    ],
  },
  '/admin/seo': {
    title: 'SEO',
    intro: 'La SEO è automatica dai contenuti reali; qui puoi rifinire i meta e usare strumenti come IndexNow.',
    steps: [
      { h: 'SEO automatica', p: 'Titoli, descrizioni e dati strutturati sono generati dai testi del CRM: non devi compilarli a mano.' },
      { h: 'Override manuali', p: 'Se serve, imposta meta personalizzati per una pagina: vincono sull\'automatico.' },
      { h: 'Anteprima social/Google', p: 'Controlla come apparirà il link su Google e sui social prima di pubblicare.' },
      { h: 'IndexNow', p: 'Nel tab IndexNow forzi la reindicizzazione su Bing/Yandex; imposta lì l\'URL del sito.' },
    ],
  },
  '/admin/connessioni': {
    title: 'Connessioni Esterne',
    intro: 'Il punto unico per collegare servizi di terze parti (Google, social, mappe, pagamenti).',
    steps: [
      { h: 'Inserisci le chiavi', p: 'Aggiungi le credenziali dei servizi che vuoi attivare (es. Google Maps, OAuth, Stripe).' },
      { h: 'Verifica lo stato', p: 'Ogni integrazione mostra se è configurata e attiva.' },
      { h: 'Sicurezza', p: 'Le chiavi segrete vengono cifrate e non vengono mai mostrate di nuovo in chiaro.' },
    ],
  },
  '/admin/audit': {
    title: 'Audit Accessi',
    intro: 'Lo storico completo degli accessi "Entra come" e delle modifiche fatte in impersonation.',
    steps: [
      { h: 'Filtra gli eventi', p: 'Cerca per data, tipo evento, admin o utente per trovare rapidamente ciò che ti serve.' },
      { h: 'Espandi il dettaglio', p: 'Ogni modifica mostra il "prima → dopo" campo per campo e il motivo dell\'accesso.' },
      { h: 'Esporta', p: 'Scarica CSV o PDF per verifiche e conformità.' },
    ],
  },
  '/admin/sicurezza': {
    title: 'Sicurezza',
    intro: 'Gli strumenti di protezione dell\'account amministratore.',
    steps: [
      { h: 'Passkey / dispositivi', p: 'Registra passkey e gestisci i dispositivi fidati per accessi più sicuri.' },
      { h: 'Rivedi gli accessi', p: 'Controlla i tentativi di accesso e revoca ciò che non riconosci.' },
      { h: 'Buone pratiche', p: 'Usa password robuste e attiva i fattori aggiuntivi dove disponibili.' },
    ],
  },
  '/admin/impostazioni': {
    title: 'Impostazioni',
    intro: 'Le impostazioni generali della piattaforma.',
    steps: [
      { h: 'Dati generali', p: 'Aggiorna le informazioni di base del sito e della piattaforma.' },
      { h: 'Salva le modifiche', p: 'Ricordati di salvare: alcune impostazioni influiscono su tutto il sito.' },
      { h: 'In caso di dubbio', p: 'Modifica un parametro alla volta e verifica l\'effetto prima di procedere.' },
    ],
  },

  // ---------------- Staff ----------------
  '/admin/staff': {
    title: 'Gestione Staff',
    intro: 'Gestisci gli operatori interni: anagrafiche, servizi offerti, zone e turni.',
    steps: [
      { h: 'Anagrafica staff', p: 'Aggiungi o modifica gli operatori e i loro dati.' },
      { h: 'Servizi e zone', p: 'Associa a ciascun operatore i servizi che svolge e le zone in cui opera.' },
      { h: 'Calendario', p: 'Pianifica disponibilità e turni nel calendario dedicato.' },
      { h: 'Email', p: 'Personalizza i template email inviati allo staff.' },
    ],
  },
};

// Prefissi verificati dal più lungo al più corto quando non c'è match esatto.
const PREFIX_KEYS = [
  '/admin/parco/guide',
  '/admin/blog',
  '/admin/newsletter',
  '/admin/esperienze',
  '/admin/pagine',
  '/admin/staff',
  '/admin/parco',
];

export function getAdminGuide(pathname) {
  if (!pathname) return null;
  // normalizza: togli eventuale slash finale (tranne la root /admin)
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  if (ADMIN_GUIDES[path]) return ADMIN_GUIDES[path];
  const hit = PREFIX_KEYS.find((k) => path === k || path.startsWith(k + '/'));
  return hit ? ADMIN_GUIDES[hit] : null;
}
